// Select2 for Colour Dropdown

// Helper to format swatches
function formatSwatch(option) {
    if (!option.id) return option.text;

    const $el = $(option.element);
    const hex = $el.data('hex-colour');
    const outline = $el.data('hex-outline');
    const type = $el.data('hex-style');

    let style = '';
    if (!hex && !type) {
        style = 'background: conic-gradient(#f5eb57,#f7c638,#f8a540,#ef6f45,#ed5043,#b23d66,#9054a0,#614da0,#5c76b5,#2ea2d2,#7bb962,#d5df58); width: 20px; height: 20px; display: inline-block; border-radius: 50%; margin-right: 8px; filter: blur(1px);';
    } else if (type === 'solid') {
        style = `background: ${hex}; width: 20px; height: 20px; display: inline-block; border-radius: 50%; margin-right: 8px;`;
    } else if (type === 'outer') {
        style = `background: ${hex}; width: 20px; height: 20px; display: inline-block; border: 2px solid ${outline}; border-radius: 50%; margin-right: 8px;`;
    } else if (type === 'half') {
        style = `background: linear-gradient(45deg, ${hex} 50%, ${outline} 50%); width: 20px; height: 20px; display: inline-block; border-radius: 50%; margin-right: 8px;`;
    }

    return $('<span><span style="' + style + '"></span>' + option.text + '</span>');
}

// Wait for the select to exist, then initialize Select2
function waitForSelect(selector, callback, interval = 100, timeout = 5000) {
    const startTime = Date.now();
    const check = setInterval(() => {
        if ($(selector).length > 0) {
            clearInterval(check);
            callback($(selector));
        } else if (Date.now() - startTime > timeout) {
            clearInterval(check);
        }
    }, interval);
}

// Initialize Select2 on page load
waitForSelect('#js-colour-switcher-drop', function($swatchSelect) {
    window.initColourDropdown($swatchSelect); // Use the global function
});

// Global function to be used to reinitialise swatch2 dropdown when the variant changes
// @ts-ignore
window.initColourDropdown = function(selectorOr$) {
    const $swatchSelect = selectorOr$ instanceof jQuery ? selectorOr$ : $(selectorOr$);
    if (!$swatchSelect.length) return;

    // Destroy previous Select2 if initialized
    if ($swatchSelect.hasClass('select2-hidden-accessible')) {
        $swatchSelect.select2('destroy');
    }

    // Initialize Select2
    $swatchSelect.select2({
        width: 'style',
        templateResult: formatSwatch,
        templateSelection: formatSwatch,
        minimumResultsForSearch: Infinity,
        dropdownCssClass: $swatchSelect.data('swatch-shape'),
        sorter: data => data.sort((a, b) => a.text.localeCompare(b.text))
    });

    // Redirect on change
    $swatchSelect.off('change').on('change', function() {
        const val = $(this).val();
        if (val) window.location = '/products/' + val;
    });
};